export const listaConfig = [{
  livro: 'A',
  qtd_paginas: 0,
  pag_inicial: 0,
  pag_final: 0,
  qtd_termo: 0,
  titulo: 'Livro A',
  frente_verso: 0,
  lado_inicial: null,
  lado_final: null
}, {
  livro: 'B',
  qtd_paginas: 0,
  pag_inicial: 0,
  pag_final: 0,
  qtd_termo: 0,
  titulo: 'Livro B',
  frente_verso: 0,
  lado_inicial: null,
  lado_final: null
}, {
  livro: 'B-AUX',
  qtd_paginas: 0,
  pag_inicial: 0,
  pag_final: 0,
  qtd_termo: 0,
  titulo: 'Livro B - Auxiliar',
  frente_verso: 0,
  lado_inicial: null,
  lado_final: null
}, {
  livro: 'C',
  qtd_paginas: 0,
  pag_inicial: 0,
  pag_final: 0,
  qtd_termo: 0,
  titulo: 'Livro C',
  frente_verso: 0,
  lado_inicial: null,
  lado_final: null
}, {
  livro: 'C-AUX',
  qtd_paginas: 0,
  pag_inicial: 0,
  pag_final: 0,
  qtd_termo: 0,
  titulo: 'Livro C - Auxiliar',
  frente_verso: 0,
  lado_inicial: null,
  lado_final: null
}, {
  livro: 'D',
  qtd_paginas: 0,
  pag_inicial: 0,
  pag_final: 0,
  qtd_termo: 0,
  titulo: 'Livro D',
  frente_verso: 0,
  lado_inicial: null,
  lado_final: null
}]

export const listaDeSequenlivros = [{
  titulo: 'Livro A',
  livro: 'A',
  num_livro_atual: 0,
  folha_atual: 0,
  termo_atual: 0,
  lado_atual: '',
}, {
  titulo: 'Livro B',
  livro: 'B',
  num_livro_atual: 0,
  folha_atual: 0,
  termo_atual: 0,
  lado_atual: '',
}, {
  titulo: 'Livro B - Auxiliar',
  livro: 'B-AUX',
  num_livro_atual: 0,
  folha_atual: 0,
  termo_atual: 0,
  lado_atual: '',
}, {
  titulo: 'Livro C',
  livro: 'C',
  num_livro_atual: 0,
  folha_atual: 0,
  termo_atual: 0,
  lado_atual: '',
}, {
  titulo: 'Livro C - Auxiliar',
  livro: 'C-AUX',
  num_livro_atual: 0,
  folha_atual: 0,
  termo_atual: 0,
  lado_atual: '',
}, {
  titulo: 'Livro D',
  livro: 'D',
  num_livro_atual: 0,
  folha_atual: 0,
  termo_atual: 0,
  lado_atual: '',
}]
